import { render } from "./Pesquisar.vue?vue&type=template&id=7bc4c2f0"
const script = {}
script.render = render

export default script